require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-aiib-comments-on-draft-policy-on-public-information.json") })
        }
      }, "path---en-us-update-aiib-comments-on-draft-policy-on-public-information");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-aiib-comments-on-draft-policy-on-public-information!./.cache/json/en-us-update-aiib-comments-on-draft-policy-on-public-information.json
// module id = 609
// module chunks = 231608221292675